import { Link } from 'react-router-dom';

interface AlertItemProps {
  icon: string;
  iconColor: 'warning' | 'critical' | 'success' | 'primary';
  title: string;
  description: string;
  link?: string;
}

export const AlertItem = ({ icon, iconColor, title, description, link }: AlertItemProps) => {
  const iconColorClasses = {
    warning: 'bg-warning/10 text-warning',
    critical: 'bg-critical/10 text-critical',
    success: 'bg-success/10 text-success',
    primary: 'bg-primary/10 text-primary',
  };

  const content = (
    <div className="flex items-start gap-3 p-4 rounded-lg bg-white border border-gray-200 hover:border-primary/40 hover:shadow-sm transition-all">
      <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${iconColorClasses[iconColor]} mt-0.5`}>
        <span className="material-symbols-outlined text-lg">{icon}</span>
      </div>
      <div className="min-w-0 flex-grow">
        <p className="font-bold text-gray-900 leading-snug">{title}</p>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
    </div>
  );

  if (link && link !== '#') {
    return <Link to={link} className="block">{content}</Link>;
  }
  return content;
};
